// extracted by mini-css-extract-plugin
export default {"container":"MapTooltip_container__awpvi","placementTop":"MapTooltip_placementTop__SiMAO","arrow":"MapTooltip_arrow__8ghv3","text":"MapTooltip_text__SoxtB"};